'use client';

import { Box, Flex, Typography } from '@coolblue-development/freddy';
import { ArrowDown, ArrowRight } from '@coolblue-development/icons';
import { memo, useState } from 'react';

import { ObjectRawData } from './ObjectRawData';

export const ObjectRawDataObject = memo(function ObjectRawDataObject({
  objectKey,
  index,
  depth,
  value,
  startExpanded = false
}: {
  objectKey: string;
  index: number;
  depth: number;
  value: object;
  startExpanded?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(startExpanded);
  const DEPTH_OFFSET = 16;

  const ObjectValue = () => {
    return (
      <Flex key={objectKey + index} gap={200}>
        <Typography
          fontSize='14px'
          mb={0}
          color='headingMain'
          sx={{
            textWrap: 'nowrap'
          }}
          fontWeight={600}
        >
          {objectKey} :
        </Typography>

        {!isOpen && (
          <Typography fontSize='14px' mb={0}>
            {`{ ... }`}
          </Typography>
        )}

        <Typography fontSize='12px' mb={0} color='interactiveSubtle'>
          {`${Object.keys(value).length} items`}
        </Typography>
      </Flex>
    );
  };

  if (Object.keys(value).length < 1) {
    return <ObjectValue />;
  }

  return (
    <>
      <Flex
        key={objectKey}
        gap={200}
        alignItems='center'
        mb={100}
        sx={{
          marginLeft: `${depth}px`,

          '&:hover': {
            cursor: 'pointer'
          }
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? (
          <Box color='subtle'>
            <ArrowDown size='small' />{' '}
          </Box>
        ) : (
          <Box color='additional'>
            <ArrowRight size='small' />
          </Box>
        )}

        <ObjectValue />
      </Flex>

      {isOpen && (
        <ObjectRawData obj={value} depth={depth + DEPTH_OFFSET} startExpended={startExpanded} />
      )}
    </>
  );
});
